<h1 matDialogTitle>Create New Order</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Store</mat-label>
        <mat-select formControlName="storeId" (selectionChange)="storeChanged()">
          <mat-option *ngFor="let store of stores" [value]="store.storeId">
            {{store.storeName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Salesperson</mat-label>
        <mat-select formControlName="salespersonCode">
          <mat-option *ngFor="let salesperson of salespersons" [value]="salesperson.salespersonCode">
            {{salesperson.salespersonName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox *ngIf="canCreateExternalOrder" (change)="isExternalOrderChanged($event)" formControlName="isExternalOrder" value="" color="primary">This is an external order</mat-checkbox>

      <mat-form-field *ngIf="form?.value.isExternalOrder" fxFlex="100" width="100%">
        <mat-label>External Provider</mat-label>
        <mat-select formControlName="externalProviderCode">
            <mat-option [value]="'LEDAINE'">Window World</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="create(false)">Create Normal Order</button>
  <button mat-button [disabled]="!form.valid" (click)="create(true)">Create Express Order</button>

</mat-dialog-actions>
